import React from "react";
import { FcGoogle } from "react-icons/fc";

const SocialButtons = ({ label = "or", onGoogleLogin, googleLoading = false }) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex items-center gap-4">
        <div className="flex-1 h-px bg-border" />
        <span className="text-[11.5px] text-text_muted whitespace-nowrap">{label}</span>
        <div className="flex-1 h-px bg-border" />
      </div>

      <button
        type="button"
        onClick={onGoogleLogin}
        disabled={googleLoading}
        className="w-full flex items-center justify-center gap-2.5 px-4 py-2.5 rounded border border-border bg-surface text-[13.5px] font-medium text-text_primary disabled:opacity-55 disabled:cursor-not-allowed"
      >
        {googleLoading ? (
          <div className="w-4 h-4 border-2 border-border border-t-text_secondary rounded-full animate-spin" />
        ) : (
          <FcGoogle size={16} />
        )}
        <span>Continue with Google</span>
      </button>
    </div>
  );
};

export default SocialButtons;
